/**
 * Heap Analytics utility functions.
 * Heap snippet is loaded in index.html.
 * All functions are no-ops when Heap is not available.
 */

export const identifyHeapUser = (userId: string): void => {
  if (typeof window.heap?.identify === "function") {
    window.heap.identify(userId);
  }
};

export const setHeapUserProperties = (
  properties: Record<string, string | number | boolean>,
): void => {
  if (typeof window.heap?.addUserProperties === "function") {
    window.heap.addUserProperties(properties);
  }
};

export const setHeapAccountProperties = (
  properties: Record<string, string | number | boolean>,
): void => {
  if (typeof window.heap?.addAccountProperties === "function") {
    window.heap.addAccountProperties(properties);
  }
};

export const resetHeapIdentity = (): void => {
  if (typeof window.heap?.resetIdentity === "function") {
    window.heap.resetIdentity();
  }
};
